
export const UPDATE_SETTINGS = 'settings/UPDATE';
export const updateSettings = settings => ({
  type: UPDATE_SETTINGS,
  payload: settings,
})

export const START_LOAD_SIDS = 'app/START_LOAD_SIDS';
export const startLoadSids = companyLogin => ({
  type: START_LOAD_SIDS,
  payload: companyLogin,
})

export const SUCCESS_LOAD_SIDS = 'app/SUCCESS_LOAD_SIDS';
export const successLoadSids = (sids, isNewLogin) => ({
  type: SUCCESS_LOAD_SIDS,
  payload: { sids, isNewLogin },
})

export const ERROR_LOAD_SIDS = 'app/ERROR_LOAD_SIDS';
export const errorLoadSids = () => ({
  type: ERROR_LOAD_SIDS,
})

